// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__1Bt9P","title":"Services_title__3qo6J"};